<template>
    <el-drawer
        :title="formData.id ? '编辑赠票' : '新增赠票' "
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                size="medium"
            >
                <el-form-item prop="ticketName" label="赠票名称:">
                    <el-input
                        v-model="formData.ticketName"
                        placeholder="请输入赠票名称"
						maxlength="20"
                    ></el-input>
                </el-form-item>				
				<el-form-item prop="electronicType" label="票品形态:">
				    <el-radio-group v-model="formData.electronicType">
				        <el-radio :label="1" border>二维码电子票</el-radio>
				        <el-radio :label="2" border :disabled="formData.id && formData.realName == 0 ? true : false">身份证电子票</el-radio>
				    </el-radio-group>
					<div><small class="color-warning">二维码电子票票夹展示二维码，身份证电子票票夹提示使用身份证入场</small></div>
				</el-form-item>
				<el-form-item prop="realName" label="是否实名:">
				    <el-radio-group v-model="formData.realName" :disabled="formData.id ? true : false">
				        <el-radio :label="0" border v-if="formData.electronicType == 1">非实名制</el-radio>
				        <el-radio :label="1" border >实名制</el-radio>
				    </el-radio-group>
				</el-form-item>			
                <!-- <el-form-item prop="datetimerange" label="验票有效期:">
                    <el-date-picker
                        v-model="formData.datetimerange"
                        type="datetimerange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        size="medium"
                        unlink-panels>
                    </el-date-picker>
                </el-form-item> -->

                <el-form-item prop="canCheckSessionIds" label="绑定验票场次:">
                    <el-select 
                        v-model="formData.canCheckSessionIds" 
                        filterable
                        multiple
                        placeholder="请输入验票场次"
                        value-key="id"
                        :disabled="formData.id && isSeat == 1 && formData.totalNum != 0 ? true : false">
                        <el-option
                            v-for="item in sessionList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> 
				<el-form-item prop="transformFlag" label="核销后再次出入场:">
				    <el-radio-group size="medium" v-model="formData.transformFlag">
				        <el-radio :label="0">关闭：门票核销后立即作废</el-radio><br>
						<el-radio :label="-1" class="MT10">开启：门票核销后暂不作废，支持自己多次出入场（不能换绑观演人）</el-radio><br>
				        <el-radio :label="1" class="MT10">开启：门票核销后暂不作废，支持出场后换绑观演人再次入场</el-radio>				        
				    </el-radio-group>
				</el-form-item>
				<el-form-item prop="transformNum" v-if="formData.transformFlag == 1">
				    <span slot="label">
				        换绑次数: 
				        <small>
				            <el-popover width="400">
				                <small>
				                    <div>表示出场后还有换绑观演人的次数</div>
				                    <div class="MT10 color-danger">注意：同一时刻只允许票品当前观演人入场</div>
									<div class="MT10">次数用完以后，可以出场，但是不能再绑定</div>
				                </small>
				                <el-link slot="reference" type="info" :underline="false" style="vertical-align: baseline;">1-100<span class="el-icon-question"></span></el-link>
				            </el-popover>
				        </small>
				    </span>
				    <el-input-number style="width:100%" v-model="formData.transformNum" :precision="0" controls-position="right" :min="1" :max="100" size="medium" placeholder="请填写支持转赠次数"></el-input-number>
				</el-form-item>
                <el-form-item prop="instruction" label="赠票说明:">
                    <el-input
                        v-model="formData.instruction"
                        placeholder="请输入赠票说明"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="presentTicketType" label="赠票类型:">
				    <el-radio-group v-model="formData.presentTicketType" :disabled="formData.id ? true : false">
				        <el-radio :label="1" border>邀请函赠票</el-radio>
				        <el-radio :label="0" border>普通赠票</el-radio>
				    </el-radio-group>
				</el-form-item>
                <template v-if="formData.presentTicketType == 1">
                    <el-form-item v-if="formData.realName == 1" prop="buyType" label="实名绑定阶段:">
                        <el-radio-group v-model="formData.buyType"> 
                            <el-radio :label="2" border>领取前实名绑定</el-radio>
                            <el-radio :label="3" border>领取后实名绑定</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item prop="endTime" label="领取截止时间:">
                        <el-date-picker
                            v-model="formData.endTime"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            default-time="23:59:59"
                            placeholder="选择领取截止时间"
                            :picker-options="endTimeOptions">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item  prop="isShowList" label="邀请名单展示:">
                        <el-radio-group v-model="formData.isShowList">
                            <el-radio :label="1" border>开启</el-radio>
                            <el-radio :label="0" border>关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </template>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确 定</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    canCheckSessionIds:[],
    instruction:'',
    presentNum:'',
    sessionName:'',
    ticketName:'',
    validEndTime:'',
    validStartTime:'',
    datetimerange:[],
	realName:0,
	electronicType:1,
    presentTicketType: 1,
    buyType: 2,
    endTime: '',
    isShowList: 0,
	transformFlag: 0,
	transformNum: 0
}
export default {
    props:{
        activityId:{
            type:[Number,String],
            default:''
        },
        isSeat: {
            type:[Number,String],
            default: 0
        }
    },
    data(){
        return{
            formData:{...defaultFormData},
            drawerShow:false,
            btnLoading:false,
            searchLoading:false,
            rules:{
                ticketName:[{ required: true, message: "请输入赠票名称" }],
				electronicType:[{ required: true, message: "请选择票品类型" }],
                datetimerange: [{ required: true, message: "请输入验票有效期" }],
                canCheckSessionIds: [{ required: true, message: "请输入验票场次" }],
				realName:[{ required: true, message: "请选择是否需要实名" }],
                endTime: [{ required: true, message: "请输入领取截止时间" }],
				transformNum: [{ required: true, message: "请填写支持转赠次数" }],
            },
            sessionList:[],
            endTimeOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 1000 * 60 * 60 * 24 * 1;
                }
            }
        }
    },
    created(){
        this.searchSession()
    },
    methods:{
        close(){
            this.formData = {...defaultFormData};
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(data){
            this.formData = data ? {
                ...defaultFormData,
                ...data,
                datetimerange:[data.validStartTime,data.validEndTime],
                canCheckSessionIds: data.sessionIds || [],
				transformFlag: data.transformNum > 0 ? 1 : data.transformNum
            } 
            : {...defaultFormData};

            this.drawerShow = true;
        },
        //检查赠票场次售票设置 
        submitForm() {
			if( this.formData.electronicType == 2 && this.formData.realName == 0 ){
				return this.$message.warning('请选择是否需要实名!')
			}
            this.$refs["formData"].validate( async (valid) => {
                if (valid) {
                   const res = await this.$request({
                        url: '/activity/checkPresentSessions',
                        data: this.formData.canCheckSessionIds,
                        method: "post",
                    }).catch(() => {
                        this.$message.error("操作失败,请重试");
                    })

                    const { state, msg ,result} = res.data;
                    if (state == 1) {
                        if( result ){
                            const _msg = `绑定的场地：${result}，仅支持售卖实体票。请确认这些场次允许电子赠票入场，否则发放的赠票用户不可用。`;
                            this.$confirm(_msg, '提示', {
                                type: 'warning',
                                center: true,
                                confirmButtonText: '继续提交',
                                closeOnClickModal: false
                            }).then(()=> {
                                this.save();
                            }).catch(()=> {})        
                        }else{
                            this.save();
                        }
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                } else {
                    return false;
                }
            });
        },
        //表单提交
        save(){
            const _url = "/activity/savePresentTP";
            this.btnLoading = true;
            const _formData = {
                ...this.formData,
                activityId:this.activityId,
				transformNum: this.formData.transformFlag > 0 ? this.formData.transformNum : this.formData.transformFlag
            }
            if( this.formData.realName != 1  ){
                delete _formData.buyType
            }
            this.$request({
                url: _url,
                data: {..._formData},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.$emit('onUpdate');						
                        this.close();

                        if(result && result.content){
                            this.$confirm(`此次提交修改了：${result.content} 。如需告知用户，请到【变动通知】页面进行操作`, '提示', {
                                // type: 'success',
                                // center: true,
                                confirmButtonText:'查看变动通知',
                                cancelButtonText:'暂不处理',
                                closeOnClickModal: false,
                                dangerouslyUseHTMLString: true,
                            }).then(() => {
                                this.$router.push(`/activityManage/activity/edit/changeNotice/${this.activityId}`)
                            }).catch(() => {
                                
                            })
                        }

                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        },
        //搜索场次
        searchSession(){
            // this.searchLoading = true;
            this.$request({
                url: '/activity/sessionNames',
                params: {activityId:this.activityId},
                method: "post",
            })
                .then((res) => {
                    const { state,result } = res.data;
                    if (state == 1) {
                        this.sessionList = result || [];
                    }
                })
                .finally(() => {
                    // this.searchLoading = false;
                });
        }
    }
}
</script>